import React, { useEffect, useState } from "react";
import "./SmartPlanFilterBar.css";
import { BaseTab } from "../BaseTab/BaseTab";
import { SearchInput } from "../Input/SearchInput";
import { TwentyIcFiltersOrder } from "../icons/TwentyIcFiltersOrder";
import Tag from "../Tag/Tag";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { TopBar } from "../TopBar/TopBar";
import { SmartPlan } from "../../../feature/Smartplan/SmartPlan";

interface SmartPlanFilterBarProps {
  filterOpened?: boolean;
  setSwitchSelected: (e: any) => any;
  setModalOpened: (e: any) => any;
  filters: Map<string, string>;
  searched: (e: any) => any;
  setFilters: (e: any) => any;
  switchStatus: number;
}

export const SmartPlanFilterBar: React.FC<SmartPlanFilterBarProps> = ({
  filterOpened,
  setSwitchSelected,
  setModalOpened,
  filters,
  searched,
  setFilters,
  switchStatus,
}) => {
  const [elementSelected, setElementSelected] = useState(switchStatus);
  const [refreshed, setRefreshed] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setElementSelected(switchStatus);
  }, [switchStatus]);

  function removeFilter(map: Map<string, string>, value: any) {
    map.forEach(function (valore, key) {
      if (valore === value) {
        map.delete(key);
      }
    });
    setFilters(map);
    setRefreshed(!refreshed);
  }

  function resetFilters(map: Map<string, string>) {
    map.clear();
    setFilters(map);
    setRefreshed(!refreshed);
  }

  function FirsTextTagReader(element: string) {
    switch (element) {
      case "duration":
        return t("smartPlan.components.tagElements.duration");
      case "location":
        return t("smartPlan.components.tagElements.location");
      case "month":
        return t("smartPlan.components.tagElements.month");
      case "includedService":
        return t("smartPlan.components.tagElements.includedService");
      case "inPromotion":
        return t("smartPlan.components.tagElements.inPromotion");
      case "minPrice":
        return t("smartPlan.components.tagElements.minPrice");
      case "maxPrice":
        return t("smartPlan.components.tagElements.maxPrice");
      case "landform":
        return t("smartPlan.components.tagElements.landform");
      default:
        return element;
    }
  }

  function SecondTextTagReader(e1: string, e2: string | string[]) {
    if (e1 == "duration") {
      if (e2 == "3") {
        return t("smartPlan.components.duration.threeDays");
      } else if (e2 == "7") {
        return t("smartPlan.components.duration.oneWeek");
      } else {
        return t("smartPlan.components.duration.twoWeeks");
      }
    } else if (e1 == "location") {
      if (Array.isArray(e2)) {
        var newEl = [] as string[];
        e2.map((el) => {
          switch (el) {
            case "NORD":
              newEl.push(t("smartPlan.components.location.nord"));
              break;
            case "SUD":
              newEl.push(t("smartPlan.components.location.sud"));
              break;
            case "CENTRO":
              newEl.push(t("smartPlan.components.location.center"));
              break;
            case "ISOLE":
              newEl.push(t("smartPlan.components.location.islands"));
              break;
          }
        });
        return newEl;
      } else {
        switch (e2) {
          case "NORD":
            return t("smartPlan.components.location.nord");
          case "SUD":
            return t("smartPlan.components.location.sud");
          case "CENTER":
            return t("smartPlan.components.location.center");
          case "ISLANDS":
            return t("smartPlan.components.location.islands");
        }
      }
    } else if (e1 == "landform") {
      switch (e2) {
        case "MOUNTAIN":
          return t("smartPlan.components.landform.mountain");
        case "SEA":
          return t("smartPlan.components.landform.sea");
        case "HILL":
          return t("smartPlan.components.landform.hill");
        case "LAKES":
          return t("smartPlan.components.landform.lakes");
        case "PARKS":
          return t("smartPlan.components.landform.parks");
        case "CITY":
          return t("smartPlan.components.landform.city");
      }
    }
  }

  useEffect(() => {
    setModalOpened(showModal);
  }, [showModal]);

  // function removeFilter(map: Map<string, string>, value: any) {
  //   map.forEach((valore, key) => {
  //     if (valore === value) {
  //       map.delete(key);
  //     }
  //   });
  //   setFilters(map);
  //   setRefreshed(!refreshed);
  // }
  const filtersExist = filters.size > 0;
  return (
    <>
      <div className="smartplan-filterbar">
        {/* BUTTON ZONE */}
        <div className="smartplan-filterBar-tabs">
          <BaseTab
            select={switchStatus === 0}
            text={t("smartPlan.components.filterBar.allSmartplan")}
            onClick={() => {
              setSwitchSelected(0);
              navigate("/smartplan");
            }}
          ></BaseTab>
          <BaseTab
            select={switchStatus === 1}
            text={"Richieste in corso"}
            onClick={() => {
              setSwitchSelected(1);
              navigate("/smartplan/request/myOrders");
            }}
          ></BaseTab>
          <BaseTab
            select={switchStatus === 2}
            text={t("smartPlan.components.filterBar.mine")}
            onClick={() => {
              setSwitchSelected(2);
              navigate("/smartplan/myOrders");
            }}
          ></BaseTab>
        </div>
        {/* END BUTTON ZONE */}
        {/* SEARCH ZONE */}
        {!elementSelected && (
          <div className="smartplan-filterBar-search">
            <SearchInput
              baseInputText={t("smartPlan.components.filterBar.searchByName")}
              inputSearched={(e) => searched(e)}
            />
            <div className="smartplan-filterBar-filterbutton">
              <BaseTab
                icon={
                  <TwentyIcFiltersOrder color="grey" className={undefined} />
                }
                select={!filterOpened}
                isButton={true}
                text={t("smartPlan.common.filters")}
                // children={
                //   !!filters &&
                //   filters?.size > 0 && (
                //     <div className="smartplan-filterBar-filterbutton-counter">
                //       <div className="smartplan-filterbar-filterbutton-counter-text">
                //         {filters.size}
                //       </div>
                //     </div>
                //   )
                // }
                onClick={() => {
                  !elementSelected && setShowModal(!showModal);
                }}
              />
            </div>
          </div>
        )}
        {/* END SEARCH ZONE */}
      </div>
      {/* TAG ZONE */}

      {!elementSelected && filters.size > 0 && (
        <React.Fragment>
          <div className="smartplan-filterBar-tags">
            <div className={"smartplan-filterBar-tags-section"}>
              {Array.from(filters.entries()).map(
                ([textOne, textTwo], index) => (
                  <Tag
                    key={index}
                    textOne={FirsTextTagReader(textOne)}
                    textTwo={SecondTextTagReader(textOne, textTwo)}
                    isRemoved={() => {
                      removeFilter(filters, textTwo);
                    }}
                  />
                )
              )}
            </div>
            {filters.size > 1 && (
              <div className="smartplan-filterBar-tags-reset">
                <Tag
                  resetAllFilterButton={true}
                  isRemoved={() => {
                    console.log(filters);

                    resetFilters(filters);
                  }}
                />
              </div>
            )}
          </div>
        </React.Fragment>
      )}
      {/* END TAG ZONE */}
    </>
  );
};
